import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputDollar from '../../../InputDollar/InputDollarView';
import { isNumeric } from '../../../../../js/app/react/validators';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';

export const validator = amount => () => {
  if (!isNumeric(amount) && +amount < 0) {
    return ['Please specify an amount'];
  }
  return [];
};

const DownPaymentView = ({
  workflowId,
  branch,
  downPayment,
  hasPlanToGetMortgage,
  alreadyHadMortgage,
  onDownpaymentChanged,
}) => (
  <AdvWorkflowStep
    branch={branch}
    workflowId={workflowId}
    canSkip={!hasPlanToGetMortgage && !alreadyHadMortgage}
  >
    <Validation
      workflowId={workflowId}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.DownPayment`}
    />
    <h2>What is your expected down payment?</h2>
    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputDollar
            isUnder
            className="md"
            placeholderClassName="adv-workflows-placeholder-large"
            placeholder="Down Payment"
            id="adv-down-payment"
            value={downPayment}
            onChange={onDownpaymentChanged(workflowId)}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(downPayment)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.DownPayment`}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
    />
  </AdvWorkflowStep>
);

DownPaymentView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  downPayment: PropTypes.number.isRequired,
  hasPlanToGetMortgage: PropTypes.bool.isRequired,
  alreadyHadMortgage: PropTypes.bool.isRequired,
  onDownpaymentChanged: PropTypes.func.isRequired,
};

export default DownPaymentView;
